import Logo from 'ui/logo';
import { Helmet } from 'react-helmet';
import { FastLogin } from './components/fastLogin';
import LoginForm from './components/LoginForm';

const LoginPage = () => {
  return (
    <>
      <Helmet>
        <title>Авторизация</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Helmet>
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#F8F9FB]">
        <Logo className="w-[260px] h-auto mb-16" />
        <LoginForm />
        <FastLogin />
      </div>
    </>
  );
};

export default LoginPage;
